import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'p-progress-bar',
    template: `
        <div class="p-progress-bar-backdrop">
            <div class="p-progress-bar">
                <mat-progress-bar class="p-progress-bar-line" mode="determinate" [value]="value"></mat-progress-bar>
                <p *ngIf="title" class="p-progress-bar-title">
                    {{ title }}
                </p>
                <p *ngIf="description" class="p-progress-bar-description" [innerHTML]="description"></p>
            </div>
        </div>
    `,
    styleUrls: ['./p-progress-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PProgressBarComponent {
    @Input() value = 0;
    @Input() description: string | undefined;
    @Input() title: string | undefined;
}
